<template>
    <div class="mb-1 text-base font-medium text-racing-stars-yellow">Step 3 of 14</div>
    <div class="w-full bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700 ">
        <div class="bg-gradient-to-r from-racing-stars-yellow to-yellow-200 h-2.5 rounded-full"
            :style="{ 'width': 7.142857143 * 3 + '%' }"></div>
    </div>
    <p class="text-center text-base  max-w-sm">The first race listed in this region is <b class="text-racing-stars-yellow">'{{ meeting.name }}'.</b></p>
    <button type="button" :v-model="tutorialStep" @click.stop="$emit('updateTutorialStep', (tutorialStep += 1));"
        class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
        Next step
    </button>
</template>

<script>
import Popper from 'vue3-popper'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon, ChevronDownIcon} from '@heroicons/vue/outline'

export default {
    props: {
        meeting: {
            type: Object,
            default: {}
        },
        tutorialStep: {
            type : Number,
        },
    },
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popper,
        ChevronDownIcon,
        ChevronUpIcon,
    },
}

</script>